import * as NgCore from '@angular/core';
import * as NgRouter from '@angular/router';
import * as NgForms from '@angular/forms';
import * as NgCommon from '@angular/common';
import * as NgCommonHttp from '@angular/common/http';
import * as NgUpgrade from '@angular/upgrade/static';
import * as NgBrowser from '@angular/platform-browser';
import * as RxOperators from 'rxjs/operators';
import * as RxObservable from 'rxjs/Observable';
import * as RxSubscription from 'rxjs/Subscription';
import * as RxBehaviorSubject from 'rxjs/BehaviorSubject';
import * as RxSubject from 'rxjs/Subject';
import * as RxOf from 'rxjs/observable/of';
import * as RxThrow from 'rxjs/observable/throw';

import * as FarmnetComponents from '@farmnet/components';
import localeDe from '@angular/common/locales/de';
import localeDeCH from '@angular/common/locales/de-CH';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeFrCH from '@angular/common/locales/fr-CH';
import localePl from '@angular/common/locales/pl';
import localeBg from '@angular/common/locales/bg';

import { CfnRoutingModule } from './routing/cfn-routing.module';

import 'script-loader!requirejs/require';

import { LoginModule } from './login/login.module';
import { AppComponent } from './components/app/app.component';

import { GuidanceLineInboxWizardModule, GuidanceLineIssueButtonComponent } from '@farmnet/fninbox-components';
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { EmptyComponent } from './routing/components/empty/empty.component';
import { HttpXsrfTokenInterceptorService } from './services/http-auth-interceptor.service';
import { FeatureToggleModule } from './feature-toggle/feature-toggle.module';
import * as angular from 'angular';
import { TestServiceComponent } from './components/test-service.component';
import * as FnwCompanion from '@farmnet/webapp-loader-companion';
import { FnxPopupModule, FnxActionBarModule } from '@farmnet/fnx-components';

declare const window : any;

//define dependencies for module resolution
window.define('@angular/router', [], () => NgRouter);
window.define('@angular/core', [], () => NgCore);
window.define('@angular/forms', [], () => NgForms);
window.define('@angular/common', [], () => NgCommon);
window.define('@angular/common/http', [], () => NgCommonHttp);
window.define('@angular/upgrade/static', [], () => NgUpgrade);
window.define('@angular/platform-browser', [], () => NgBrowser);
window.define('rxjs/operators', [], () => RxOperators);
window.define('rxjs/Observable', [], () => RxObservable);
window.define('rxjs/Subscription', [], () => RxSubscription);
window.define('rxjs/BehaviorSubject', [], () => RxBehaviorSubject);
window.define('rxjs/observable/of', [], () => RxOf);
window.define('rxjs/observable/throw', [], () => RxThrow);
window.define('rxjs/Subject', [], () => RxSubject);
window.define('@farmnet/components', [], () => FarmnetComponents);
window.define('@farmnet/webapp-loader-companion', [], () => FnwCompanion);

NgCommon.registerLocaleData(localeDe, 'de');
NgCommon.registerLocaleData(localeDeCH, 'de-CH');
NgCommon.registerLocaleData(localeEn, 'en');
NgCommon.registerLocaleData(localeFr, 'fr');
NgCommon.registerLocaleData(localeFrCH, 'fr-CH');
NgCommon.registerLocaleData(localePl, 'pl');
NgCommon.registerLocaleData(localeBg, 'bg');
@NgCore.NgModule({
    imports: [
        NgBrowser.BrowserModule,
        NgForms.FormsModule,
        NgCommon.CommonModule,
        NgUpgrade.UpgradeModule,
        LoginModule,
        CfnRoutingModule,
        GuidanceLineInboxWizardModule,
        FarmnetComponents.Fn2ComponentsModule,
        FeatureToggleModule,
        FnwCompanion.FnwNavigationModule,
        FnwCompanion.WebappLoaderCompanionModule.forRoot({
            serviceName: '',
            isMonolith: true
        }),
        FnxPopupModule,
        FnxActionBarModule
    ],
    declarations: [
        AppComponent,
        EmptyComponent,
        TestServiceComponent
    ],
    providers: [
        {
            provide: 'navigationService',
            useFactory: getNavigationService,
            deps: ['$injector'],
        },{
            provide: 'moduleLoading',
            useFactory: getModuleLoadingService,
            deps: ['$injector'],
        },{
            provide: '$route',
            useFactory: getRoute,
            deps: ['$injector'],
        },{
            provide: '$location',
            useFactory: getLocation,
            deps: ['$injector'],
        },{
            provide: '$scope',
            useFactory: getScope,
            deps: ['$rootScope'],
        },{
            provide: '$timeout',
            useFactory: getTimeout,
            deps: ['$injector'],
        },{
            provide: HTTP_INTERCEPTORS,
            useClass: HttpXsrfTokenInterceptorService,
            multi: true,
        }

    ],
    bootstrap: [
        AppComponent,
    ],
    entryComponents: [
        EmptyComponent,
        GuidanceLineIssueButtonComponent,
    ]
})
export class CfnModule {
}

function getNavigationService($injector: angular.auto.IInjectorService) {
    return $injector.get('navigationService');
}

function getModuleLoadingService($injector: angular.auto.IInjectorService) {
    return $injector.get('moduleLoading');
}

function getLocation($injector: angular.auto.IInjectorService) {
    return $injector.get('$location');
}

function getTimeout($injector: angular.auto.IInjectorService) {
    return $injector.get('$timeout');
}

function getScope($rootScope: angular.IRootScopeService) {
    return $rootScope.$new();
}

function getRoute($injector: angular.auto.IInjectorService) {
    return $injector.get('$route');
}
